import { useCallback } from "react";
import { useSearch, useNavigate } from "@tanstack/react-router";
import type { FileExplorerSearchParams } from "../../types";

export function useFileExplorerSearchParams() {
  const search = useSearch({
    from: "/file-explorer/$categoryName",
  }) as FileExplorerSearchParams;
  const navigate = useNavigate({ from: "/file-explorer/$categoryName" });

  const updateSearchParams = useCallback(
    (updates: Partial<FileExplorerSearchParams>) => {
      const newSearch: Record<string, string | undefined> = {};
      const preservedParams = new Set(["tab", "page", "itemsPerPage"]);

      Object.entries(search).forEach(([key, value]) => {
        if (value !== undefined && value !== "") {
          newSearch[key] = String(value);
        }
      });

      Object.entries(updates).forEach(([key, value]) => {
        if (preservedParams.has(key)) {
          return;
        }
        if (value === undefined || value === "") {
          delete newSearch[key];
        } else {
          newSearch[key] = String(value);
        }
      });

      navigate({
        search: newSearch,
        replace: true,
      });
    },
    [search, navigate]
  );

  return {
    search,
    updateSearchParams,
  };
}
